<script setup lang="ts">
import { AppStandardModal } from '@libs/ui';

import type { TicketOption } from '../models/changeTicket';
import { useChangeTicketModalStore } from '../stores/changeTicketModalStore';

import TicketOptionCard from './TicketOptionCard.vue';

interface ChangeTicketModalProps {
  ticketOptions: TicketOption[];
}

const props = defineProps<ChangeTicketModalProps>();

interface ChangeTicketModalEmits {
  (eventName: 'confirm', selectedTicketType: string): void;
  (eventName: 'close'): void;
}

const emit = defineEmits<ChangeTicketModalEmits>();

const changeTicketModalStore = useChangeTicketModalStore();
changeTicketModalStore.initializeStore(props.ticketOptions);
</script>

<template>
  <AppStandardModal
    class="change-ticket-modal"
    @close="emit('close')"
    @confirm="emit('confirm', changeTicketModalStore.selectedTicketType)"
  >
    <template #title>
      <slot name="header-text">
        <span class="header-text">
          {{ $t('planner.transport.change_ticket') }}
        </span>
      </slot>
    </template>

    <template #body>
      <div class="ticket-options">
        <TicketOptionCard
          v-for="ticketOption of props.ticketOptions"
          :key="ticketOption.type"
          :ticket-option="ticketOption"
          :base-price="changeTicketModalStore.basePrice"
          :selected-ticket-type="changeTicketModalStore.selectedTicketType"
          @select-ticket-type="changeTicketModalStore.selectTicketType"
        />
      </div>
    </template>

    <template #button>
      {{ $t('planner.done') }}
    </template>
  </AppStandardModal>
</template>

<style scoped lang="scss">
.change-ticket-modal {
  .ticket-options {
    display: flex;
    flex-flow: column;
    gap: var(--spacing-16);
    margin-bottom: var(--spacing-16);
  }
}
</style>
